
export default {
  'navbar.lang': 'isiZulu',
  'menu.home': 'Ikhaya',
  'menu.dashboard': 'Ishidi Lomsebenzi',
  'menu.profile': 'Iphrofayela',
  'menu.settings': 'Izilungiselelo',

  'user.login.title': 'Iskeni Iphumelele!',
  'user.login.subtitle': 'Nika imininingwane yakho ukuze uqhubeke',
  'user.login.username': 'Igama lomsebenzisi noma i-imeyili',
  'user.login.password': 'Iphasiwedi',
  'user.login.forgot': 'Ukhohlwe iphasiwedi?',
  'user.login.button': 'Ngena',
  'user.register.title': 'Dala i-akhawunti entsha',
  'user.register.button': 'Bhalisa',
  'user.register.success': 'I-akhawunti idalwe. Hlola i-imeyili ukuze uqinisekise.',

  'user.login.welcome.subheading': 'Siyakwamukela emhlabeni lapho inkululeko ihlangana nempilo ekhethekile! Skena. Thola amaphuzu. Phila ngokukhululekile. Phila ngokukhethekile',
  'user.login.description': 'Usuphumelele ukuskenea ikhodi yethu ye-QR. Ngena noma Bhalisa ngezansi ukuze ucele imiklomelo namaphuzu',
  'user.login.signin.title': 'Ngena',
  'user.login.signin.sub': 'Ukuze ungene sicela faka inombolo yakho yocingo; sizothumela ikhodi yokuqinisekisa',
  'user.login.phoneNumberLabel': 'Inombolo yocingo',
  'user.login.enterPhonePlaceholder': 'Faka inombolo yakho yocingo',
  'user.login.invalidPhone': 'Inombolo yocingo ayivumelekile',
  'user.login.phoneRequired': 'Kudingeka inombolo yocingo',
  'user.login.signingIn': 'Kungena...',
  'user.login.continue': 'Qhubeka',
  'user.login.noAccount': 'Awunayo i-akhawunti?',
  'user.login.signup': 'Bhalisa',
  'user.login.footerCopyright': '© {year} Amalungelo agodliwe. Kunikezwe yi Exceptional Brands',

  'user.register.welcome': 'Siyakwamukela!',
  'user.register': 'Bhalisa ukuze ucele imiklomelo yakho',
  'user.register.description': 'Gcwalisa imininingwane yakho ngezansi ukuze uthole amaphuzu, uvule imiklomelo futhi uwine imiklomelo emangalisayo',
  'user.register.phone.label': 'Inombolo yocingo',
  'user.register.phone.placeholder': 'Faka inombolo yocingo',
  'user.register.phone.required': 'Kudingeka inombolo yocingo',
  'user.register.phone.invalid': 'Inombolo yocingo ayivumelekile',
  'user.register.name.label': 'Igama lakho',
  'user.register.name.placeholder': 'isib. Mark',
  'user.register.name.required': 'Kudingeka igama',
  'user.register.ageGroup.label': 'Iqembu leminyaka (Ongakukhetha)',
  'user.register.gender.label': 'Ubulili (Ongakukhetha)',
  'user.register.gender.male': 'Owesilisa',
  'user.register.gender.female': 'Owesifazane',
  'user.register.terms.agreement': 'Ngokuqhubeka, uyavuma {termsLink} and {privacyLink}.',
  'user.register.terms.termsOfService': 'Imigomo Yesevisi',
  'user.register.terms.privacyPolicy': 'Inqubomgomo yobumfihlo',
  'user.register.creating': 'Kudala iphrofayela…',
  'user.register.create': 'Yakha iphrofayela',
  'user.register.alreadyAccount': 'Usunayo i-akhawunti?',
  'user.register.signin': 'Ngena',
  'user.register.footer.copyright': '© {year} Amalungelo agodliwe. Kunikezwe yi Exceptional Brands',

  "user.welcome.welcome": "Siyakwamukela!",
  "user.welcome.welcome_name": "Siyakwamukela {name}!",
  'user.welcome.points_earned': 'Halala, uwine',
  'user.welcome.thank_you': 'Siyabonga ngokubhalisa!',
  'user.welcome.earn_more_points': 'Ukuze uthole amaphuzu amaningi, baphendule imikhiqizo eminingi oyithengile kithi.',
  'user.welcome.continue': 'Qhubeka',
  'user.welcome.logging_in': 'Ukuqala sesi...',
  "user.welcome.welcome_reward": "Umvuzo Wokwamukela",
  "user.welcome.points_label": "amaphuzu!",
  "user.welcome.loggingIn": "Ukuqala sesi...",

  "product.button.continue": "Qhubeka",
  "product.button.selectToContinue": "Khetha umkhiqizo ukuze uqhubeke",

  'scansuccess.review.heading': 'Uzowulinganisa kanjani lo mkhiqizo?',
  'scansuccess.review.continue': 'Ikhodi yomthengisi (Kuyakhethwa)',
  'scansuccess.review.select-product': 'Engeza ikhodi yomthengisi ukuze uthole amaphuzu amaningi',
  'scansuccess.review.review-products': 'Thumela Ukubuyekeza',

  "product.retailerCode.label": "Ikhodi yomthengisi",
  "product.retailerCode.requiredLabel": "Kuyadingeka",
  "product.retailerCode.optionalLabel": "Kuyakhethwa",
  "product.retailerCode.placeholder": "Faka ikhodi yomthengisi",
  "product.retailerCode.aria": "Ikhodi yomthengisi",
  "product.retailerCode.hintRequired": "Ikhodi yomthengisi iyadingeka ukuze uthumele lesi sibuyekezo",
  "product.retailerCode.hintOptional": "Faka ikhodi yomthengisi ukuze uthole amaphuzu amaningi",
  "product.retailerCode.error.required": "Ikhodi yomthengisi iyadingeka",
  "product.retailerCode.error.invalid": "Ikhodi yomthengisi ayilungile",

  "profile.title": "Iphrofayela Yami",
  "profile.tier.member": "Ilungu",
  "profile.points": "Amaphuzu",
  "profile.pointsEarned": "Amaphuzu Awunqobile",
  'scansuccess.continue': 'Qhubeka',
  "profile.completeTitle": "Qeda Iphrofayela Yakho",
  "profile.completeSubtitle": "Thola amaphuzu ayi {points} engeziwe!",
  "profile.completedTitle": "Iphrofayela Iqediwe! ✓",
  "profile.completedSubtitle": "Utholile wonke amaphuzu ayi {points} engeziwe!",
  "profile.completeButton": "Qeda Iphrofayela (+{points} pt)",
  "profile.redeem": "✓ Iphrofayela Iqediwe",
  "product.review.placeholder": "Bhala ukubuyekeza... (uhlamvu olulodwa lanele)",
  "product.review.ariaLabel": "Bhala ukubuyekeza",
  "profile.field.phoneNo.label": "Inombolo yocingo",
  "profile.field.phoneNo.add": "Faka inombolo yakho",
  "profile.field.email.label": "Ikheli Le-imeyili",
  "profile.field.email.add": "Faka i-imeyili yakho",
  "profile.field.countryCode.label": "Indawo",
  "profile.field.countryCode.add": "Faka indawo yakho",
  "profile.field.name.label": "Igama",
  "profile.field.name.add": "Faka igama lakho",
  "profile.field.dateOfBirth.label": "Usuku lokuzalwa",
  "profile.field.dateOfBirth.add": "Faka usuku lwakho lokuzalwa",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Buyekeza {field}",
  "profile.modal.completeTitle": "Qeda Iphrofayela Yakho",
  "profile.modal.update": "Buyekeza",
  "profile.modal.complete": "Qeda Iphrofayela",
  "profile.modal.cancel": "Khansela",
  "profile.completedBadge": "Uthole amaphuzu {points}",
  "profile.progressPercent": "{percent}% Imukamile",
  "profile.progressRemaining": "{percent}% esele",
  'scansuccess.congratulations.heading': 'Halala!',
  'scansuccess.congratulations.continue': 'Uthole',
  'scansuccess.congratulations.select-product': 'Siyabonga ngokubuyekeza kwakho',
  'scansuccess.congratulations.review-products': 'Ukuze uthole amaphuzu amaningi, linganisa imikhiqizo eminingi oyithengile kithi',
  'scansuccess.congratulations.create': 'Hamba kuDashibodi',
  'user.brand-product-review.title': 'Khetha uMkhiqizo & Ibhande Ukuze Uqhubeke',
  'user.brand-product-review.continue': 'Qhubeka',
  'user.brand-product-review.select-product': 'Khetha umkhiqizo ukuze uqhubeke',
  'user.brand-product-review.review-products': 'Bukeza imikhiqizo yethu ukuze uthole amaphuzu',
  'user.brand-product-review.rate-product': 'Sicela ulinganise okungenani umkhiqizo owodwa ngenhla ukuze uqhubeke',
  'user.brand-product-review.footer': '© {year} Izethembiso ezikhethekile',
  'scansuccess.title': 'Imiphumela yokuqhafaza',
  'scansuccess.scan.message': 'Siyabonga — ukuskena kwakho kuphumelele.',
  'scansuccess.scan.instructions': 'Ungafaka amaphuzu, ubhale ukubuyekeza noma ubhalise kuzipesheli.',
  'scansuccess.signup.title': 'Bhalisa ukuze uthole imiklomelo',
  'scansuccess.signup.button': 'Bhalisa',
  'scansuccess.welcomepoints.title': 'Amaphuzu Okamukelo',
  'scansuccess.welcomepoints.pointsLabel': 'Amaphuzu anikeziwe',
  'scansuccess.brandproductreview.title': 'Ukubuyekezwa komkhiqizo nebhande',
  'scansuccess.brandproductreview.leaveReview': 'Shiya ukubuyekeza',
  'scansuccess.productreview.title': 'Ukubuyekezwa Komkhiqizo',
  'scansuccess.productreview.submit': 'Thumela ukubuyekeza',
  'scansuccess.congratulations.title': 'Halala!',
  'scansuccess.congratulations.message': 'Uthole amaphuzu — hlola i-dashboard yakho ukuze uwafake isicelo.',
  'scansuccess.noAccount': 'Awunayo i-akhawunti?',
  'scansuccess.signup': 'Bhalisa',

  "user.register.createProfile": "Dala i-akhawunti",
  "user.register.creatingProfile": "Kwakha i-akhawunti...",
  "user.register.termsOfService": "Imigomo yesevisi",
  "user.register.privacyPolicy": "Inqubomgomo yobumfihlo",

  'dashboard.multiplescans.title': 'Ama-scan amaningi',
  'dashboard.multiplescans.instructions': 'Phatha ama-scan amaningi nezimklomelo ndawonye.',
  'dashboard.title': 'Siyakwamukela!',
  'dashboard.balance': 'Ibhalansi yakho',
  'dashboard.balance-sub': 'amaphuzu',
  'dashboard.redeem': 'Faka isicelo',
  'dashboard.stat': 'Isamba sama-scan',
  'dashboard.label': 'Imiklomelo oyinqobile',
  'dashboard.redeem.title': 'Faka isicelo samaphuzu akho',
  'dashboard.redeem.success': 'Faka isicelo semiklomelo',
  'dashboard.primary-sub': 'Sebenzisa amaphuzu akho ukuvula imiklomelo',
  'dashboard.secondary-btn': 'Scanisha futhi',
  'dashboard.secondary': 'Biza umngane',
  'dashboard.loyalty': 'Izigaba zokuthembeka',
  'dashboard.5000pts': '5000 amaphuzu',
  'dashboard.100pts': '100 amaphuzu ku-Platinum',
  'dashboard.almost-there': 'Siseduze!',
  'dashboard.recent': 'Imisebenzi yakamuva',
  'settings.title': 'Izilungiselelo',
  'settings.balance': 'Ilungu le-Gold',
  'settings.balance-sub': 'Amaphuzu',
  'settings.redeem': 'I-akhawunti',
  'settings.stat': 'Hlela iphrofayela',
  'settings.label': 'Buyekeza ulwazi lomuntu siqu',
  'settings.redeem.title': 'Okuthandwayo',
  'settings.redeem.success': 'Izaziso',
  'settings.primary-sub': 'Izintandokazi zokucindezela & i-imeyili',
  'settings.secondary-btn': 'Ulimi',
  'settings.secondary': 'isiZulu',
  'settings.loyalty': 'Usizo & Imibandela',
  'settings.5000pts': 'Usizo & Ukusekela',
  'settings.100pts': 'FAQ, thintana nathi',
  'settings.almost-there': 'Imibandela & Imigomo',
  'settings.recent': 'Ulwazi lwezomthetho',
  'settings.points': 'Inqubomgomo yobumfihlo',
  'settings.data': 'Ulwazi lokuvikelwa kwedatha',
  'settings.sign': 'Phuma',

  'profile.balance': '% Iqediwe',
  'profile.balance-sub': '% eseleyo',
  'profile.stat': 'Ulwazi lwephrofayela',
  'profile.label': 'pt',
  'profile.redeem.title': 'Xhuma imidiya yakho',
  'profile.redeem.success': 'Thola amaphuzu ngokuxhuma ngakunye!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Xhuma imidiya yakho ukuze uthole ibhonasi yamaphuzu ayi-20!',
  'profile.recent': 'Gcwalisa imikhakha elandelayo ukuze uqede iphrofayela yakho futhi uthole ',
  

  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "Ningizimu Afrika",
  "country.BJ": "Benin",
  "country.AE": "I-UAE",

  "dashboard.welcome": "Siyakwamukela!",
  "dashboard.user.unknown": "Umsebenzisi",
  "dashboard.balanceLabel": "Ibhalansi yakho",
  "dashboard.coinsAlt": "izikhwama",
  "dashboard.pointsLabel": "amaphuzu",
  "dashboard.redeemBtn": "Sebenzisa amaphuzu",
  "dashboard.totalScans": "Izakamuva zonke",
  "dashboard.rewardsWon": "Imiklomelo oyinqobile",
  "dashboard.redeemTitle": "Faka isicelo samaphuzu",
  "dashboard.redeemRewards": "Faka imiklomelo",
  "dashboard.redeemSub": "Sebenzisa amaphuzu ukuvula imiklomelo",
  "dashboard.reviewProducts": "Hlola imikhiqizo",
  "dashboard.referFriend": "Biza umngane",
  "dashboard.tiersTitle": "Izigaba zokuthembeka",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "Siseduze!",
  "dashboard.recentActivityTitle": "Imisebenzi yakamuva",
  "dashboard.share.title": "Joyina Exceptional Brands",
  "dashboard.share.text": "Joyina nami ku-Exceptional Brands! Thola amaphuzu ngokuskanisa imikhiqizo futhi uthole imiklomelo emangalisayo. Sebenzisa isixhumanisi sami: {url}",
  "dashboard.shareModalTitle": "Yabelana nabangani",
  "dashboard.shareModalDesc": "Yabelana nge-Exceptional Brands nabangani bakho bese uthola amaphuzu okwengeza lapho bezobhalisa!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Isixhumanisi sakho sokuncoma:",
  "dashboard.share.instagramCopied": "Isixhumanisi sikopiwe ku-clipboard - namathisela ku-Instagram",
  "dashboard.footerCopyright": "© {year} Izinqumo ezikhethekile",
  "dashboard.aria.welcome": "Iphaneli yokwamukela",
  "dashboard.aria.notifications": "Izaziso",
  "dashboard.aria.settings": "Izilungiselelo",
  'dashboard.redeem.points': 'Faka amaphuzu akho',
  'dashboard.redeem.subtitle': 'Sebenzisa amaphuzu ukuvula imiklomelo',
  'dashboard.redeem.sub': 'amaphuzu',
  'dashboard.redeem.progress': 'Inqubekela phambili eya ku-Platinum',
  'dashboard.redeem.stat': 'Imiklomelo etholakalayo',
  'dashboard.redeem.label': 'Faka isicelo',
  'dashboard.redeem.need': 'Kudingeka',
  'dashboard.redeem.prize': 'Landa umklomelo',
  'dashboard.redeem.scan': 'Lapho uskanisa kakhulu, amathuba wakho okuwina okuthile amahle ayakhula',
  'dashboard.redeem.recent': 'Imisebenzi yakamuva',
  'global.back': 'Buyela emuva',
  'global.next': 'Okulandelayo',
  'global.search.placeholder': 'Sesha...',
  'validation.required': 'Le ndawo iyadingeka',
  'error.404.title': 'Ikhasi alitholakali',
  'error.404.subTitle': 'Siyaxolisa, asikwazi ukuthola ikhasi olifunayo.',
};
